var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonRemoval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 69,
    viewBox: "0 0 74 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0434 26.0219C50.0434 23.1958 52.8695 23.1958 52.8695 23.1958C52.8695 23.1958 55.6956 23.1958 55.6956 26.0219C55.6956 28.848 50.0434 34.5001 50.0434 34.5001H55.6956",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8043 20.3696C45.8043 17.2482 43.2735 14.7174 40.1521 14.7174C37.0307 14.7174 34.5 17.2482 34.5 20.3696V28.8478C34.5 31.9692 37.0307 34.5 40.1521 34.5C43.2735 34.5 45.8043 31.9692 45.8043 28.8478V20.3696Z",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2608 20.3696C30.2608 17.2482 27.7301 14.7174 24.6087 14.7174C21.4873 14.7174 18.9565 17.2482 18.9565 20.3696V28.8478C18.9565 31.9692 21.4873 34.5 24.6087 34.5C27.7301 34.5 30.2608 31.9692 30.2608 28.8478",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.4565,
    cy: 41.5653,
    r: 1.05978,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8913 18.9565C6.35712 20.0743 2 24.3975 2 30.2609C2 36.9502 6.615 41.5652 13.3043 41.5652H45.8043",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0869 6.23917C30.8041 4.74629 28.8478 3.41309 24.6087 3.41309C16.5819 3.41309 10.4782 10.9298 10.4782 18.9566",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1086 41.5652H59.9347C66.6241 41.5652 71.2391 36.9502 71.2391 30.2609C71.2391 24.324 66.7979 18.9565 57.1086 18.9565",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2608 10.4783C33.0869 4.82608 37.627 2 44.3913 2C56.5032 2 61.3478 11.6892 61.3478 18.9565",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 45.8043V62.7608",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9782 50.0435V62.7608",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4348 55.6957L38.7391 67L50.0434 55.6957",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1738 64.1739C74.3534 62.6924 72.2769 51.5216 71.2391 44.3914C71.2391 44.3914 71.0723 47.8533 62.7608 50.0435C55.9287 51.8437 57.1086 59.9348 57.1086 59.9348",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8695 65.587C52.8695 65.587 62.7608 62.7609 68.413 51.4565",
    stroke: "#4FC899",
    strokeWidth: 2.11956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonRemoval);
export default __webpack_public_path__ + "static/media/Carbon-Removal.15a08596025f2c90f1e210aa60e06b40.svg";
export { ForwardRef as ReactComponent };